module.exports = __webpack_public_path__ + "static/3-bf7aa2848f6456c8bb4b202d0eb81270.svg";